import React from 'react';
import { Editor } from './Editor.js';
import { highlight as prismHighlight, languages } from 'prismjs/components/prism-core';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/themes/prism-tomorrow.css';

interface CodeEditorProps {
  value: string;
  readOnly?: boolean;
  onChange?: (value: string) => void;
}

function CodeEditor({ value, readOnly = true, onChange }: CodeEditorProps) {
  const highlight = (code: string) => prismHighlight(code || '', languages.js);

  return (
    <Editor
      value={JSON.stringify(value, null, 2)}
      onValueChange={onChange ?? (() => {})}
      highlight={highlight}
      readOnly={readOnly}
      padding={10}
      style={{
        fontFamily: 'var(--mono, monospace)',
        fontSize: 12,
        background: 'var(--bg-deep, #0e1117)',
        border: '1px solid var(--bs, rgba(255,255,255,0.06))',
        borderRadius: 4,
        color: 'var(--t1, #eef2ff)',
        minHeight: 60,
        maxHeight: 320,
        overflow: 'auto',
      }}
    />
  );
}

export default CodeEditor;
